/* =========================================================
   Affiche MUSCULATION « Mes Records » — le PR board.
   API : SNMuscuRecords.render(data, opts) -> string SVG
     data : { title, name, bw, city, discipline, season, footer,
              l1,k1,d1, l2,k2,d2, l3,k3,d3, l4,k4,d4 }
       lN = nom du mouvement, kN = charge (kg), dN = date du record
     opts : { palette }
   Le TOTAL et les ratios × poids de corps sont CALCULÉS automatiquement.
   Auto-suffisant (aucune carte) → re-render serveur direct pour l'impression.
   ========================================================= */
(function () {
  const PW = 800, PH = 1066, MX = 66;

  const PALETTES = {
    craie: { label: 'Craie', bg: '#F7F4ED', ink: '#0B2D5B', muted: '#8B94A3', accent: '#FF6B2C', line: '#E3DDD0', box: '#0B2D5B', boxInk: '#F7F4ED', boxMuted: '#93A1B8' },
    nuit:  { label: 'Nuit',  bg: '#0B2D5B', ink: '#F7F4ED', muted: '#93A1B8', accent: '#FF6B2C', line: '#1E4272', box: '#12355F', boxInk: '#F7F4ED', boxMuted: '#93A1B8' },
    fonte: { label: 'Fonte', bg: '#15191F', ink: '#F5F2EA', muted: '#8A93A0', accent: '#FF6B2C', line: '#272D36', box: '#1D232B', boxInk: '#F5F2EA', boxMuted: '#8A93A0' },
    acier: { label: 'Acier', bg: '#E7E9EC', ink: '#14243B', muted: '#77808F', accent: '#FF6B2C', line: '#D3D7DD', box: '#14243B', boxInk: '#F7F4ED', boxMuted: '#93A1B8' },
  };

  const esc = s => String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;');
  const up = s => String(s == null ? '' : s).toUpperCase();
  // plus grande taille de police où `text` tient dans `maxW` (avance ≈ cwf·taille + ls).
  const fitSize = (text, maxW, maxSize, cwf, ls, minSize) => {
    const n = String(text).length || 1; minSize = minSize || 12;
    for (let s = maxSize; s > minSize; s -= 1) if (n * (cwf * s + ls) <= maxW) return s;
    return minSize;
  };
  // "82,5 kg" / "82.5" → 82.5 ; sinon null
  const num = s => { const m = String(s == null ? '' : s).replace(',', '.').match(/-?\d+(\.\d+)?/); return m ? parseFloat(m[0]) : null; };
  const fmt = n => (Math.round(n * 100) / 100).toFixed(2).replace(/\.?0+$/, '').replace('.', ',');

  function miniBarbell(cx, y, color) {
    return `<g fill="${color}">`
      + `<rect x="${cx - 96}" y="${y - 1.6}" width="192" height="3.2" rx="1.6"/>`
      + `<rect x="${cx - 104}" y="${y - 11}" width="8" height="22" rx="2.5"/>`
      + `<rect x="${cx - 114}" y="${y - 8}" width="6.5" height="16" rx="2.5"/>`
      + `<rect x="${cx + 96}" y="${y - 11}" width="8" height="22" rx="2.5"/>`
      + `<rect x="${cx + 107.5}" y="${y - 8}" width="6.5" height="16" rx="2.5"/>`
      + `</g>`;
  }

  function render(data, opts) {
    data = data || {}; opts = opts || {};
    const p = PALETTES[opts.palette] || PALETTES.craie;
    const cx = PW / 2;

    /* --- en-tête --- */
    const bw = num(data.bw);
    const head = [up(data.name) || 'VOTRE NOM', data.bw ? up(data.bw) : '', up(data.city)].filter(Boolean).join(' · ');
    const headLs = head.length > 38 ? 2 : head.length > 30 ? 3 : 4.5;
    const headSize = fitSize(head, 690, 19, 0.58, headLs, 12);
    const title = up(data.title) || 'MES RECORDS';
    const titleLs = title.length > 18 ? 2 : 3;
    // max 74 + baseline 184 : la boîte d'ascente Oswald (≈1,2×) reste à ≥10 px
    // sous le sur-titre (baseline 78) — accents É compris.
    const titleSize = fitSize(title, 700, 74, 0.54, titleLs, 34);
    const sub = [up(data.discipline), up(data.season)].filter(Boolean).join(' · ');

    /* --- lignes de records --- */
    const rows = [];
    for (let i = 1; i <= 4; i++) {
      const label = up(data['l' + i]).trim();
      const kg = data['k' + i];
      if (!label && !String(kg || '').trim()) continue;
      rows.push({ label: label || 'MOUVEMENT', kg: kg, date: up(data['d' + i]).trim(), n: num(kg) });
    }
    if (!rows.length) {
      rows.push({ label: 'SQUAT', kg: '', date: '', n: null },
        { label: 'DÉVELOPPÉ COUCHÉ', kg: '', date: '', n: null },
        { label: 'SOULEVÉ DE TERRE', kg: '', date: '', n: null });
    }

    const Y0 = 318, Y1 = 826;                       // zone des lignes
    const step = (Y1 - Y0) / rows.length;
    const kgSize = rows.length >= 4 ? 76 : 92;
    let body = '';
    rows.forEach((r, i) => {
      const y = Y0 + step * i;
      const labelSize = r.label.length > 20 ? 20 : r.label.length > 15 ? 23 : 26;
      body += `<text x="${MX}" y="${y + 40}" font-size="${labelSize}" font-weight="700" fill="${p.ink}" letter-spacing="2">${esc(r.label)}</text>`;
      if (r.date) body += `<text x="${MX}" y="${y + 70}" font-size="16" font-weight="600" fill="${p.muted}" letter-spacing="1.5">${esc(r.date)}</text>`;
      body += `<text x="${PW - MX}" y="${y + 66}" text-anchor="end" font-family="Oswald" font-weight="700" fill="${p.ink}">`
        + `<tspan font-size="${kgSize}">${esc(String(r.kg || '').trim() || '—')}</tspan>`
        + `<tspan font-size="${Math.round(kgSize * 0.38)}" fill="${p.accent}" dx="6">KG</tspan></text>`;
      if (r.n != null && bw) body += `<text x="${PW - MX}" y="${y + 94}" text-anchor="end" font-size="15" font-weight="600" fill="${p.muted}">${fmt(r.n / bw)} × poids de corps</text>`;
      if (i < rows.length - 1) body += `<line x1="${MX}" y1="${y + step - 26}" x2="${PW - MX}" y2="${y + step - 26}" stroke="${p.line}" stroke-width="1.5"/>`;
    });

    /* --- total calculé --- */
    const totals = rows.map(r => r.n).filter(n => n != null);
    const total = totals.length ? fmt(totals.reduce((a, b) => a + b, 0)) : '—';
    const totalLabel = up(data.totalLabel) || 'TOTAL';

    return `<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 ${PW} ${PH}" font-family="'Sora','Inter',sans-serif">
<rect width="${PW}" height="${PH}" fill="${p.bg}"/>
<text x="${cx}" y="78" font-size="${headSize}" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="${headLs}">${esc(head)}</text>
<text x="${cx}" y="184" font-family="Oswald" font-size="${titleSize}" font-weight="700" fill="${p.ink}" text-anchor="middle" letter-spacing="${titleLs}">${esc(title)}</text>
${sub ? `<text x="${cx}" y="212" font-size="17" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="4">${esc(sub)}</text>` : ''}
${miniBarbell(cx, 258, p.ink)}
${body}
<rect x="54" y="852" width="${PW - 108}" height="150" rx="16" fill="${p.box}"/>
<text x="${cx}" y="890" font-size="16" font-weight="700" fill="${p.accent}" text-anchor="middle" letter-spacing="8">${esc(totalLabel)}</text>
<text x="${cx}" y="984" text-anchor="middle" font-family="Oswald" font-weight="700" fill="${p.boxInk}"><tspan font-size="88">${esc(total)}</tspan><tspan font-size="35" fill="${p.accent}" dx="7">KG</tspan></text>
<text x="${cx}" y="1042" font-size="15" font-weight="600" fill="${p.muted}" text-anchor="middle" letter-spacing="5">${esc(up(data.footer) || 'LE PALMARÈS CONTINUE')}</text>
</svg>`;
  }

  window.SNMuscuRecords = { render, PALETTES };
})();
